import { get, post } from "../utility/fetch-util";

/**
 * Get the messages for the signed in user
 */
export const getMessages = async (progress) => {
    return get('/api/message/all', null, progress);
}

/**
 * Mark message as read
 */
export const markMessageAsRead = async (messageId, progress) => {
    return post('/api/message/' + messageId + '/read', null, progress);
}

/**
 * Remove message
 */
export const removeMessage = async (messageId, progress) => {
    return post('/api/message/' + messageId + '/delete', null, progress);
}
